import styled, { createGlobalStyle } from "styled-components";
import { Modal } from "antd";
import { rgba } from "config/variable";

export const SecureGlobalStyle = createGlobalStyle`
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
* { 
  scrollbar-width: thin; 
  scrollbar-color: ${(props) => props.theme.colorlightgrey} transparent; 
} 
body {
  margin: 0;
  padding: 0;
  position: relative;
  font-family: "Roboto", sans-serif;
}
  a {
    text-decoration: none;
  }
/* Global utilty class define */
.flex-shrink-0 {
  flex-shrink: 0;
}

.d-flex {
  display: flex;
}
.gap-2 {
    gap: 0.5rem;
}
 .gap-x-2{
     column-gap: 0.5rem;
}
 .gap-y-2 {
    row-gap: 0.5rem;
}
 .gap-2-5 {
    gap: 0.625rem;
}
 .gap-x-2-5 {
    column-gap: 0.625rem;
}
 .gap-y-2-5 {
     row-gap: 0.625rem;
}
 .gap-3 {
    gap: 0.75rem;
}
 .gap-x-3{
     column-gap: 0.75rem;
}
 .gap-y-3 {
    row-gap: 0.75rem;
}
 .gap-3-5 {
    gap: 0.875rem;
}
 .gap-x-3-5 {
    column-gap: 0.875rem;
}
 .gap-y-3-5{
     row-gap: 0.875rem;
}
 .gap-4 {
    gap: 1rem;
}
 .gap-x-4 {
    column-gap: 1rem;
}
 .gap-y-4{
     row-gap: 1rem;
}
 .gap-5 {
    gap: 1.25rem;
}
.row-reverse{
  flex-direction: row-reverse;
}
.justify-content-start {
  justify-content: flex-start;
}
.justify-content-end {
  justify-content: flex-end;
}
.justify-content-center{
  justify-content: center;
}
.justify-content-between{
  justify-content: space-between;
}
.align-item-center{
  align-items: center;
}
.align-item-end{
  align-items: end;
}
.align-items-start{
  align-items: flex-start;
}
.flex-direction-columnu{
  flex-direction: column;
}
.border-0 {
  border: none;
}

.rotate-135 {
  transform: rotate(135deg);
}

.rotate-90 {
  transform: rotate(90deg);
}

.rotate-minus-90 {
  transform: rotate(-90deg);
}

.opacity-50 {
  opacity: 0.5;
}

.font-7{
  font-size:7px
}
.font-14{
  font-size: 14px!important;
}
.font-16{
  font-size: 16px!important;
}
.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.position-relative {
  position: relative;
}

.w-100 {
  width: 100%;
}

.max-w-180 {
  max-width: 180px;
}

.max-w-135 {
  max-width: 135px;
}
.h-42{
  height: 42px;
}
.h-36{
  height: 36px;
}
.box-shadow-none{
  box-shadow: none!important;
}
.h-100{
  height: 100%;
}
.capitalize {
  text-transform: capitalize;
}
.lock {
  color: ${(props) => props.theme.primary};
}
  .mobile-table-block{
    display: flex;
    flex-direction: column;
    gap: 15px;
     @media (min-width: 0px) and (max-width: 820px){
        padding-bottom: 50px;
        padding-top: 105px;
        .refresh-icon{
          width: auto;
        }
 
     }
  }
 .mobile-hide {
    display: flex;  
    @media (min-width: 0px) and (max-width: 820px) {
      display: none;
    }
  }
  .tab-hide{
    display: flex; 
    align-items: center;
    @media (min-width: 0px) and (max-width: 1199px) {
      display: none;
    }
  }
  .desktop-hide {
    display: none;
    align-items: center;
    @media (min-width: 0px) and (max-width: 820px) {
      display: flex;
    }
  }
.ant-typography{
&.typo-6{
      font-weight: 500;
    font-size: 15px;
}
}
.ant-input-number-input{
  height: 42px!important;
}
.pointer{
  cursor: pointer;
} 
.text-primary{
  color: ${(props) => props.theme.primary};
} 
.fw-500{
  font-weight: 500;
}
.ant-form-vertical {
  .ant-form-item{
    .ant-form-item-label {
      padding-bottom: 0 !important;
    }
  }

}
.error-container{
  .error-wrapper{
    .error-content{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 10px;
       height: 100%;
        width: 100%; 
        padding: 15px;
        background: ${(props) => props.theme.colordwhitedark};
        border: 1px solid ${(props) => props.theme.colorbluegreylight};
        border-radius: 8px;
        font-size: 16px; 
    }
  }
}
textarea{
    &.ant-input{
    background-color: transparent !important;
    &.ant-input-disabled {
    color: ${(props) => props.theme.textcolorlightgrey};
  }
  }

}
.ant-form-item-required{
  &:before{
  right: -1px!important;
}
}
.mx-10{
  margin: 0 10px;
}
.my-10{
  margin: 10px 0;
}
.mx-5{
  margin: 0 5px;
}
.my-5{
  margin: 5px 0;
}
.px-10{
  padding: 0 10px;
}
.py-10{
  padding: 10px 0;
}
.px-5{
  padding: 0 5px;
}
.py-5{
  padding: 5px 0;
}
.border-b{
  border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight}; 
}
.ant-input-wrapper{
  &.ant-input-group{
    .ant-input{
      box-shadow: none!important;;
    }
  } 
}
.ant-tag{
  border-radius: 100px;
  font-size: 11px;
  line-height: 18px;
  background-color: ${(props) => props.theme.tagbgcolor};
  border-color:${(props) => props.theme.tagbgcolor};
  color: #fff;
  &.ant-tag-default{
    background-color: ${(props) => props.theme.colorbluegrey};
    border-color: ${(props) => props.theme.colorbluegrey};
  }

}
/* style for floating button */
.ant-float-btn-default{
  .ant-float-btn-body{
   background-color: ${(props) => props.theme.primary};
   &:hover{
     background-color: ${(props) => props.theme.primary};
   }
   .anticon{
    color: ${(props) => props.theme.textcolordwhite3};
   }
}
}
/* Modal style override for background mask */
.ant-modal-root {
  .ant-modal-mask {
   background-color: ${(props) => rgba(props.theme.bgcolordarkblue, 0.6)}
  }
}
/* Select default style override */
.ant-select-item{ 
  &.ant-select-item-option{ 
    &.ant-select-item-option-selected{ 
      color: ${(props) => props.theme.textcolordblack}!important;
          background-color: transparent; 
      }
       &.ant-select-item-option-active{
        color: ${(props) => props.theme.textcolordwhite3};
       }
    }
}
.ant-select-multiple{
  .ant-select-selection-item{
    /* display: none; */
  }
}
.ant-dropdown{
  .ant-dropdown-menu{
      background-color: ${(props) => props.theme.colordwhitedark};
  }
}
.ant-select-dropdown,.ant-dropdown-menu{
   background-color: ${(props) => props.theme.colordwhitedark};
   &.ant-select-dropdown-m-w-150 {
    min-width: 155px !important;
   }
    .ant-select-item{
    &.ant-select-item-option{
      &.ant-select-item-option-selected{
        background: ${(props) => props.theme.bglightblue};
      }
    }
  }
}
.ant-select-dropdown-bordered,
  .ant-dropdown-bordered .ant-dropdown-menu {
  padding: 0;
  border-radius: 8px;
  box-shadow: 0px 7px 33px -2px ${(props) =>
    rgba(props.theme.colortileblack, 0.05)};
  .anticon{
    font-size: 14px;
    margin-right: 8px;
    color:#8083A3
  }
  .ant-select-item,
  .ant-dropdown-menu-item {
    padding: 9px 12px;
    border-radius: 0;
    font-size: 12px;
    min-height: 38px;
    &:not(:last-child) {
      border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight}; 
    }
  }
}
.ant-dropdown-bordered .ant-dropdown-menu {
    overflow: auto;
    .ant-dropdown-menu-item-selected{
      color: ${(props) => props.theme.textcolordwhite3}; 
      background-color: ${(props) => props.theme.bgcolordarkblue}; 
    }
    .ant-dropdown-menu-item:hover {
      background-color: ${(props) => props.theme.bgcolordarkblue}; 
      color: ${(props) => props.theme.textcolordwhite3}; 
    }
    .ant-dropdown-menu-item-disabled {
      color: ${(props) => rgba(props.theme.textcolordblack, 0.25)};  
    }
}
/* Tool-Tip Component CSS Started */
.ant-tooltip {
  .ant-tooltip-inner {
    border-radius: 2px;
    font-size: 14px;
    background-color: ${(props) => props.theme.bgcolordblack} ;
    color: ${(props) => props.theme.textcolordwhite};
  }
  .ant-tooltip-arrow{
    &::before{
       background-color: ${(props) => props.theme.bgcolordblack} ;
    }
  }
  .net-test{
    min-width:180px;
    ul{
      li{
        display:flex;
        justify-content:space-between;
        font-size:12px;
        .bad {
        color: ${(props) => props.theme.colordanger};
      }
      .good {
        color: ${(props) => props.theme.orangeopacity};
      }
        b{
          font-size:14px;
        }
      }
    }
  }
}
/* style for form group lable required global style position  */
.ant-form-item{
    margin-bottom: 16px;
}
.ant-form-item-explain-error {
    font-size: 12px;
     color: ${(props) => props.theme.colordanger}; 
}
.ant-form-item-required{
    &:before{
      position: absolute;
      right: -12px;
      font-size: 18px !important;
    }
}
/* style for range picker */
.ant-modal-range-picker {
  .ant-modal-close {
    position: static;
    display: block;
    margin: -12px -12px 10px auto;
    color: ${(props) => props.theme.textcolordarkgrey};
    &:hover {
      background-color: transparent;
    }
  }
}
.ant-modal-middle-space {
  .ant-modal-content {
    padding: 24px;
    .ant-modal-header {
      margin-bottom: 24px;
    }
    .ant-modal-title {
      font-size: 20px;
      line-height: 32px;
    }
  }
}
/* style for form group design  */
.form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    .label {
      font-size: 14px;
      height: auto;
      color: ${(props) => props.theme.textcolordblack};
      margin-right: 30px;
      min-height: 25px;
      display: flex;
      align-items: center;
      &::after {
        display: none;
      }
    }
    .input-row {
      display: flex;
      align-items: center;
      gap: 12px; 
      margin-top: 8px;
    }
}
textarea{
  &.ant-input{
    background-color: transparent;
  }
}
/* style for global checkbox and checkbox group */
  .ant-checkbox-inner {
    height: 18px;
    width: 18px;
    border: 1.5px solid ${(props) => props.theme.colorbluegrey};
    border-radius: 4px;
    background-color: transparent;
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${(props) => props.theme.primary};
      border-color: transparent;
      &:after {
        border-color: ${(props) => props.theme.textcolordwhite3};
      }
    }
  }
  /* style for global radio label */
  .ant-radio-wrapper{
     font-size: 14px;
      height: auto;
      color: ${(props) => props.theme.textcolordblack}; 
  }
  .ant-wave{
    display: none!important;
  }

  /* Contact group member style */
  .ant-table-cell {
    .member-column {
      color: ${(props) => props.theme.primary};
      cursor: pointer;
      width: auto;
      text-decoration: underline;
    }
    .alertSent-column {
      cursor: pointer;
      width: auto;
      text-decoration: underline;
    }
  }
  /* Select search add style */
  .person-search {
    position: relative;
    &.search-icon {
      .ant-select-selector {
        .ant-select-selection-search {
          padding-left: 35px !important;
        }
      }
      .ant-select-selection-placeholder {
        padding-left: 0;
      }
    }
    .ant-select {
      margin-bottom: 20px;
    }
    .error-msg {
      font-size: 12px;
      color: ${(props) => props.theme.colordanger};
    }
    .ant-select-selector,
    .ant-select-selection-placeholder {
      padding-left: 50px;
    }
    .tagbar {
      background: ${(props) => rgba(props.theme.bglightblue, 0.3)};
      border: 1px solid ${(props) => props.theme.bordercolordlightblue};
      box-shadow: inset 0px 0px 1px 1px
        ${(props) => rgba(props.theme.bgcolordwhite, 0.36)};
      border-radius: 8px;
      padding: 8px;
      max-height: 162px;
      overflow: auto;
    }
    .search-icon {
      position: absolute;
      top: 13px;
      left: 10px;
      border-right: 1px solid ${(props) => props.theme.textcolordarkgrey};
      margin-right: 10px;
      padding-right: 10px;
      display: flex;
      align-items: center;
    }
  }
   /* style for popover sidebar */
  .popover-sidebar-overlay{
    .ant-popover-inner{
      background-color: ${(props) => props.theme.bgcolordwhiteblack}!important;
    }
    .ant-popover-arrow{
      &:before,&:after{
        background: ${(props) => props.theme.bgcolordwhiteblack}!important;
      }
    }
  }
  .popover-sidebar{ 
    width: 300px; 
    .sidebar-item{
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 12px;
      text-align: center;
      margin-bottom: 20px;
      cursor: pointer;
      .icon-wrapper{
        width: 40px;
        height: 40px;
        border: 1px solid ${(props) => props.theme.bordercolorsharpgrey}; 
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 8px;
        font-size: 17px;
        color: ${(props) => props.theme.textcolordblack};
      }
    }
  }
  /* style for ant picker  */
  .ant-picker-dropdown{
    .ant-picker-ok{
      .ant-btn-primary{
        color: ${(props) => props.theme.textcolordblack}!important;
      }
    }
  }
  /* style for toast msg  */
  .ant-message-notice-content{
    background-color: ${(props) => props.theme.bgcolordwhiteblack} !important;
    color: ${(props) => props.theme.textcolordblack};
    box-shadow: 0px 25px 40px -10px ${(props) =>
      rgba(props.theme.colortileblack, 0.08)} !important;
    border: 1px solid ${(props) => props.theme.bgborderlight};
  }
  /* style for popover msg  */
  .ant-popover{
    .ant-popover-inner{
       background-color: ${(props) =>
         props.theme.bgcolordwhiteblack} !important;
    color: ${(props) => props.theme.textcolordblack};
    box-shadow: 0px 25px 40px -10px ${(props) =>
      rgba(props.theme.colortileblack, 0.08)} !important;
    border: 1px solid ${(props) => props.theme.bgborderlight};
    }
  }
  /* style for multile picker  */
  .ant-select{
    &.ant-select-multiple{
      .ant-select-selection-item{
         background-color: ${(props) => props.theme.multipleselectcolor};
          border-color: ${(props) => props.theme.multipleselectcolor};
      }
    }
  }
  /* style for empty data */
  .ant-empty{
    .ant-empty-description{
         color: ${(props) => props.theme.textcolordblack};
    }
  }
  /* Style for blast */
  .contact-group,
  .contact-person {
    border: 1px solid ${(props) => props.theme.colorsharpgrey};
    border-radius: 8px;
    padding: 20px;
    background-color: ${(props) => props.theme.bgcolordwhiteblack};
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: grab;
    margin-bottom: 10px;
    &__left {
      flex: 1;
      font-size: 20px;
      display: flex;
      align-items: center;
      .name-data {
        margin-left: 12px;
        .name {
          font-size: 13px;
          font-weight: 600;
          color: ${(props) => props.theme.textcolordblack};
        }
        .data {
          font-size: 13px;
          color: ${(props) => props.theme.textcolordarkgrey};
        }
      }
    }
    &__right {
      .standard {
        font-size: 12px;
        color: ${(props) => props.theme.textcolordarkgrey};
      }
    }
  }
  .react-tel-input {
    .form-control {
    border: 1px solid ${(props) => props.theme.bordercolorgrey};;
    border-radius: 8px;
    height: 42px;
    
  }
  .flag-dropdown{
      border-radius: 8px 0 0 8px
    }
  }
  /* style for upload wrapper */
  .upload-wrapper {
    display: flex;
    align-items: center;
    &.compose-fax{
      flex-direction:column;
      align-items:flex-start;
    }
    .anticon{
      &.anticon-paper-clip{
        color: ${(props) => props.theme.textcolordblack} !important;
      }
    }
    .ant-upload-wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .ant-upload-list-item {
      border: transparent !important;
      padding: 0 10px!important;
      height: auto !important;
      margin-bottom: 0px;
      margin-top: 0;
      margin-left: 0px; 
      .ant-upload-list-item-progress {
        display: none;
      }
      .ant-btn {
        &:hover {
          background-color: transparent;
        }
      }
      .ant-upload-list-item-name {
        font-size: 12px;
        color: ${(props) => props.theme.textcolordarkgrey};
        flex: none;
        max-width: 90px;
      }
      .anticon-removeicons {
        font-size: 18px;
        color: ${(props) => props.theme.textcolordarkgrey}!important;
      }
      .ant-upload-list-item-thumbnail {
        width: 30px;
        height: 30px;
      }
    }
  }
  //cover page details modal style 
.cover-page-details-modal{
  .ant-select{
    .ant-select-selector{
      max-height: 200px;
      overflow: auto;
    }
  }
 
  .cover-page-data-wrapper{
     background: ${(props) => rgba(props.theme.bgborderlight ?? "", 0.36)};
      border: 1px solid ${(props) => props.theme.bordercolordlightblue};
      box-shadow: inset 0px 0px 1px 1px
        ${(props) => rgba(props.theme.bgcolordwhite, 0.36)};
      border-radius: 8px;
      padding: 12px;
      margin: 15px 0;
      .cover-pag-name-block{
        display: flex;
        flex-direction: column;
        font-size: 14px;
        &:first-child {
          margin-bottom: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
        }
        .head{
          font-weight: 500;
        }
        .detail{
          color: ${(props) => props.theme.textcolordarkgrey};
        }
      }
  }
}
.ant-drawer{
  .filter-drawer{
        background: ${(props) => props.theme.colordwhitedark};
        .anticon-close{
          color: ${(props) => props.theme.textcolordblack};
        }
    &.ant-drawer-content{
      .ant-drawer-header{
        padding: 16px;
            border-color: ${(props) => props.theme.colorbluegreylight};
              .ant-drawer-title{
                font-weight: 500;
                font-size: 16px;
              }
      }
      .ant-drawer-body{
        padding: 24px;
        font-size: 14px;
        .date-filter-wrapper{
          margin: 0;
        }
      }
    }
  }
}
`;
export const Heading6 = styled.h6`
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.textcolordblack};
`;
export const Heading5 = styled.h5`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.textcolordblack};
`;
export const Heading4 = styled.h4`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  color: ${(props) => props.theme.textcolordblack};
`;
export const Customtagbar = styled.span`
  display: block;
  margin-top: 10px;
  .ant-tag {
    border-radius: 50px;
    height: 32px;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    margin: 3px 5px;
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    background-color: ${(props) => props.theme.multipleselectcolor};
    border-color: ${(props) => props.theme.multipleselectcolor};
    color: ${(props) => props.theme.colorlightblack};
    &.primary {
      background-color: ${(props) => props.theme.primary};
      color: ${(props) => props.theme.textcolordwhite3};
    }
    .data {
      max-width: 184px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .profilecover-icon-wrapper {
      display: flex;
      align-items: center;
      width: 24px;
      height: 24px;
      overflow: hidden;
      border-radius: 100%;
      margin-right: 6px;
      background: ${(props) => props.theme.primary};
      font-size: 12px;
      color: ${(props) => props.theme.textcolordwhite3};
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      font-size: 6px;
      .ant-avatar {
        font-size: 11px;
        font-weight: normal;
        background-color: transparent;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .ant-tag-close-icon {
      font-size: 15px;
      margin-left: 7px;
    }
  }
 
`;
export const CollapseStyleBar = styled.div`
  margin: 16px 0 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  .ant-collapse {
    border: 1px solid ${(props) => props.theme.colorbluegreylight};
    border-radius: 8px;
    overflow-x: hidden;
    max-height: calc(100vh - 370px);
    overflow-y: auto;
    margin-bottom: 16px;
    .ant-collapse-item {
      border-bottom: none;
      overflow: hidden;
      &.ant-collapse-item-active {
        .ant-collapse-header {
          background-color: ${(props) => props.theme.bgcolordskybluelight};
        }
      }
      .ant-collapse-header {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        background-color: ${(props) => props.theme.testblock};
        border-radius: 0;
        .ant-collapse-expand-icon {
          color: ${(props) => props.theme.textcolordblack};
        }
        .ant-collapse-extra {
          .anticon-EditIcon {
            color: ${(props) => props.theme.primary};
          }
        }
      }
      .ant-collapse-content {
        background: ${(props) => props.theme.colordwhitedark};
        border-top-color: ${(props) => props.theme.colorbluegreylight};
        .ant-collapse-content-box {
          padding: 16px;
          .data-block {
            .schedule {
              list-style: none;
              padding: 0;
              margin: 16px 0;
              display: flex;
              li {
                display: flex;
                flex-direction: column;
                padding: 0 30px;
                border-right: 1px solid #eceef5;
                &:first-child {
                  padding-left: 0;
                }
                &:last-child {
                  border-right: none;
                }
                span {
                  color: ${(props) => props.theme.customselect};
                  font-size: 12px;
                }
              }
            }
            label {
              font-size: 14px;
              font-weight: 500;
            }
            .label-details {
              font-size: 12px;
              color: ${(props) => props.theme.customselect};
            }
          }
        }
      }
    }
  }
`;
export const AlertContactsBlockStyle = styled.div`
  .alert-list {
    display: flex;
    justify-content: space-between;
    border: 1px solid ${(props) => props.theme.colorbluegreylight};
    background-color: ${(props) => props.theme.testblock};
    padding: 16px;
    border-radius: 8px;
    align-items: center;
    margin: 12px 0;
    .anticon {
      cursor: pointer;
    }
    .anticon-EditIcon {
      color: ${(props) => props.theme.primary};
    }
    .checked-alerts {
      width: 501px;
      display: flex;
      justify-content: space-between;
      max-width: 100%;
      .ant-checkbox-group {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .ant-checkbox-disabled {
          + span {
            color: ${(props) => props.theme.customselect};
          }
        }
      }
    }
    .alert-name {
      color: ${(props) => props.theme.textcolordblack};
      font-size: 15px;
      font-weight: 500;
      min-width: 120px;
      width: 240px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .remove {
      font-size: 20px;
      cursor: pointer;
    }
  }
`;
export const AccInfoWrapper = styled.div`
  background-color: ${(props) => props.theme.bgcolordwhiteblack};
  border-radius: 10px;
  padding: 24px;
  /* height: 100%; */
  &.accountsettings {
    height: 100vh;
  }

  .heading5 {
    padding-bottom: 24px;
  }
`;
export const FormFooter = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid ${(props) => props.theme.colorbluegreylight};
`;
export const LabelStyle = styled.span`
  font-size: 14px;
  height: auto;
  color: ${(props) => props.theme.textcolordblack};
`;
export const CardWrap = styled.div`
  border: 1px solid ${(props) => props.theme.multipleselectcolor};
  border-radius: 8px;
  padding: 12px;

  .cardrow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.multipleselectcolor};
    padding-bottom: 12px;
    margin-bottom: 12px;
    .ant-btn {
      min-width: 243px;
    }
    &:last-child {
      border: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
`;
export const PStyle = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colorlightblack};
  font-weight: 600;
`;
export const SpanStyle = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${(props) => props.theme.colorbluegrey};
`;
// Global style for modal start
const ModalStyle = styled(Modal)` 
  .ant-modal-content {
    padding: 24px;
    .ant-modal-header {
      margin-bottom: 22px;
      .ant-modal-title {
        font-size: 20px;
        color: ${(props) => props.theme.textcolordblack};
        .subtitle {
          font-size: 14px;
          font-weight: normal;
          color: ${(props) => props.theme.colorbluegrey};
          margin-top: 5px;
        }
        .refresh-wrapper {
          position: relative;
        }
        .refresh-list {
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          color: ${(props) => props.theme.textcolordarkgrey};
        }
      }
    }
    .ant-modal-footer {
      .footerleft {
        display: flex;
        align-items: center;
        height: 100%;
      }
      .footerright {
        display: flex;
        justify-content: flex-end;
      }
    }
    .ant-modal-close {
      display: none;
    }
    .ant-modal-body {
      .ant-btn {
        padding: 0 12px;
        width: 100%;
      }
      .ant-select {
        width: 100%;
      }
    }
  }
  .ant-modal-header {
    margin-bottom: 25px;
    .modal-title-icon {
      font-size: 16px;
      display: flex;
      align-items: flex-start;
      font-weight: normal;
      .anticon {
        font-size: 20px;
        margin-right: 18px;
        color: ${(props) => props.theme.colordanger};
      }
    }
    .ant-modal-title {
      font-size: 20px;
      font-weight: 700;
    }
  }
  .custom-msg-wrapper {
    .head {
      background: ${(props) => props.theme.bgborderlight};
      padding: 20px;
      border-radius: 8px;
      margin-bottom: 10px;
    }
    .listing-data {
      font-size: 14px;
      padding: 20px;
      border: 1px solid ${(props) => props.theme.colorbluegreylight};
      border-radius: 8px;
      p {
        margin-bottom: 5px;
      }
    }
    .org-blast {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 50px;
      .leftarrow {
        font-size: 40px;
        color: ${(props) => props.theme.primary};
      }
      &__left,
      &__right {
        background: ${(props) => props.theme.bglightblue};
        border: 1px solid ${(props) => props.theme.colorbluegreylight};
        border-radius: 8px;
        padding: 20px;
        margin: 20px 0;
      }
    }
  }
  .spanstyle {
    font-size: 14px;
    line-height: 16px;
  }

  /* here global style end  */
`;

export default ModalStyle;


